// Dependencies.
import styled, { css } from 'styled-components'

import { H3 } from './H3'
import { H4 } from './H4'
import { P } from './P'
import { howItWorkStyles } from './howItWorkStyles'

// Props.
export interface HowItWorkItem {
  title: string
  content: string | React.ReactNode
}

interface Props {
  items: HowItWorkItem[]
  className?: string
}

// Styles
const Section = styled.section`
  ${howItWorkStyles}
`

// Hosted By.
export const HowItWork: React.FC<Props> = (props) => {
  // Props
  const { items, className } = props

  // ..
  return (
    <Section className={className}>
      <div className="container">
        {items.map((item, key) => {
          return (
            <div key={key} className="hiwItem">
              {/* Point title and number */}
              <div className="section">
                <div className="numberContainer">
                  <H3 className="number">{key + 1}</H3>
                </div>
                <div className="titleContainer">
                  <H4 className="title">{item.title}</H4>
                </div>
              </div>

              {/* Detail about point */}
              <div className="section">
                <div className="numberContainer hide" />
                <div className="titleContainer">
                  <P className="content">{item.content || ''}</P>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </Section>
  )
}
